//let dateFormat = require('dateformat');
let moment = require('moment-timezone');


// Allows each date to be displayed in the same format.
exports.formatToLocalDate = function(date) {
  if (!date) return;

  try {
    let date_local = new Date(module.exports.DateTimeFromUTCToLocalString(date));
    return moment.utc(date_local).local().format("MMM DD, YYYY"); // ex: Feb 06, 2023
  } catch (error) {
  }
};

// Allows each date to be displayed in the same format and according to the proper timezone.
exports.formatToLocalDateTime = function(date) {
  if (!date) return;

  try {
    let date_local = new Date(module.exports.DateTimeFromUTCToLocalString(date));
    return moment.utc(date_local).local().format("MMM DD, YYYY - hh:mm A"); // ex: Feb 06, 2023 - 12:36 PM
  } catch (error) {
  }
};


// Convert a UTC date in iso_8601 format to local iso_8601
// 2023-02-10T05:07:35 (UTC) would become 2023-02-10T00:07:35 in Toronto Timezone (-05:00)
exports.DateTimeFromUTCToLocalString = function(date) {
  return moment.utc(date).local().format('YYYY-MM-DDTHH:mm:ss');
};

// Format a number of seconds (number) to mm:ss string
exports.convertSecondToTimeLabel = function(p_seconds, p_n_digits=3) {
  let sign = "";
  if (p_seconds < 0) {
    sign = "-";
    p_seconds = p_seconds * -1;
  }

  let hours = ~~(p_seconds / 3600);
  let minutes = ~~((p_seconds - hours*3600) / 60);
  // let minutes = Math.floor(p_seconds / 60);  // Math.floor() is slower than '~~'
  minutes = (minutes < 10 && hours > 0) ? "0" + minutes : minutes;
  let extraSeconds = p_seconds % 60;
  extraSeconds = extraSeconds < 10 ? "0" + extraSeconds.toFixed(p_n_digits) : extraSeconds.toFixed(p_n_digits);
  if (hours > 0)
    return sign + hours + ":" + minutes + ":" + extraSeconds;
  return sign + minutes + ":" + extraSeconds;
}

// Format a number of seconds (number) to [0h00m0.00s]
// Similar to convertSecondToTimeLabel but only return characters allowed in file names.
exports.convertSecondToTimeLabelForFileName = function(p_seconds) {
  let sign = "";
  if (p_seconds < 0) {
    sign = "-";
    p_seconds = p_seconds * -1;
  }

  let hours = ~~(p_seconds / 3600);
  let minutes = ~~((p_seconds - hours*3600) / 60);
  // let minutes = Math.floor(p_seconds / 60);  // Math.floor() is slower than '~~'
  minutes = (minutes < 10 && hours > 0) ? "0" + minutes : minutes;
  let extraSeconds = p_seconds % 60;
  extraSeconds = extraSeconds < 10 ? "0" + extraSeconds : extraSeconds;
  if (hours > 0)
    return sign + hours + "h" + minutes + "m" + extraSeconds + "s";
  return sign + minutes + "m" + extraSeconds + "s";
}
